import React, {useCallback, useContext, useMemo, useRef, useState} from "react";
import {Datatable} from "../../../../shared/components/datatable/Datatable";
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import {Tag, Button, Space} from "antd";

const MISSION_TYPE = {
    DAILY: 1,
    LOOPING: 2,
    NEW_USER: 3,
    MONTHLY: 4,
    COMEBACK: 5
};

const Mission = () => {
    const {playerData} = useContext(PlayerContext);
    const [missionType, setMissionType] = useState(MISSION_TYPE.DAILY);
    const missions = playerData.playerInfo.missionContentsDatas?.AttendanceMissionDatas || {};

    const columnData = useCallback(() => {
        switch (missionType) {
            case MISSION_TYPE.DAILY:
                return missions.Daily ? Object.values(missions.Daily) : [];
            case MISSION_TYPE.LOOPING:
                return missions.Looping ? Object.values(missions.Looping) : [];
            case MISSION_TYPE.NEW_USER:
                return missions.NewUser ? Object.values(missions.NewUser) : [];
            case MISSION_TYPE.MONTHLY:
                return missions.Monthly ? Object.values(missions.Monthly) : [];
            case MISSION_TYPE.COMEBACK:
                return missions.Comeback ? Object.values(missions.Comeback) : [];
            default:
                return [];
        }
    }, [missions, missionType]);

    const refreshRef = useRef(null);

    const columns = useMemo(() => ([
        {
            title: '미션 아이디',
            dataIndex: 'index',
        },
        {
            title: '횟수',
            dataIndex: 'count',
        },
        {
            title: '진행 상태',
            dataIndex: 'state',
            render: (_, {state}) => {
                let color, text;
                switch (state) {
                    case 0:
                        color = 'blue';
                        text = '진행중';
                        break;
                    case 1:
                        color = 'green';
                        text = '완료';
                        break;
                    case 2:
                        color = 'purple';
                        text = '보상받음';
                        break;
                    default:
                        color = 'lightgray';
                        text = 'Unknown';
                }
                return <Tag color={color}>{text}</Tag>;
            },
        },
    ]), []);

    return (
        <div>
            <Space style={{ display: 'flex', gap: 8, margin: 16 }}>
                <Button
                    onClick={() => setMissionType(MISSION_TYPE.DAILY)}
                    type={missionType === MISSION_TYPE.DAILY ? 'primary' : 'default'}
                >
                    일일 미션
                </Button>
                <Button
                    onClick={() => setMissionType(MISSION_TYPE.LOOPING)}
                    type={missionType === MISSION_TYPE.LOOPING ? 'primary' : 'default'}
                >
                    반복 미션
                </Button>
                <Button
                    onClick={() => setMissionType(MISSION_TYPE.MONTHLY)}
                    type={missionType === MISSION_TYPE.MONTHLY ? 'primary' : 'default'}
                >
                    일일 출석
                </Button>
                <Button
                    onClick={() => setMissionType(MISSION_TYPE.NEW_USER)}
                    type={missionType === MISSION_TYPE.NEW_USER ? 'primary' : 'default'}
                >
                    신규 유저 출석
                </Button>
                <Button
                    onClick={() => setMissionType(MISSION_TYPE.COMEBACK)}
                    type={missionType === MISSION_TYPE.COMEBACK ? 'primary' : 'default'}
                >
                    컴백 유저 출석
                </Button>
            </Space>
            <Datatable columns={columns} refresh={refreshRef} rows={columnData()}/>
        </div>
    );
};

export default Mission;